import { X } from 'lucide-react';

/**
 * Soothing full-screen overlay. Soft animated gradient background with a slow
 * "breathing" orb that pulses in and out. Pure CSS animations.
 */
export default function TakeABreakOverlay({ onClose }) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden break-overlay">
      {/* Animated gradient background */}
      <div className="absolute inset-0 break-gradient" />

      {/* Drifting blobs for ambient motion */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      {/* Breathing orb in the center */}
      <div className="relative flex flex-col items-center">
        <div className="breathing-orb" />
        <div className="mt-12 text-center text-white/90 select-none pointer-events-none">
          <p className="font-heading text-4xl uppercase tracking-wider mb-3 breathing-text">Breathe</p>
          <p className="text-base font-body italic opacity-80">In through the nose. Out through the mouth.</p>
        </div>
      </div>

      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/15 backdrop-blur-md
          border border-white/30 text-white hover:bg-white/25 transition-all
          flex items-center justify-center"
        title="Close"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
